import { useEffect } from "react";

import { clearSession } from "../../config/cookies";

const ExternalRedirect = ({ url, exit = false, doLogoutAppExit }: { url: string, exit?: boolean, doLogoutAppExit?: any  }) => {
  useEffect(() => {

    if(exit) {
      clearSession();
      doLogoutAppExit();
    }

    window.location.href = url;
  }, [url]);

  return null;
};

export default ExternalRedirect;
